import React, { createContext, useContext, useMemo, useState } from 'react';
import { Snackbar } from '@mui/material';
import i18n from 'i18next';
import { getErrorMessage } from 'utils/errorMessage';
import './Notification.scss';

const NotificationContext = createContext({
  showNotification: (msg: unknown) => {
  }
});

const useNotification = () => useContext(NotificationContext);

interface INotificationProviderProps {
  children: React.ReactNode
}

const NotificationProvider = ({ children }: INotificationProviderProps) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const showNotification = useMemo(
    () => (msg: unknown) => {
      // Server errors can arrive as objects; never show "[object Object]" or raw JSON.
      setMessage(getErrorMessage(msg, i18n.t('errors.anErrorOccurred')));
      setOpen(true);
    },
    [setMessage, setOpen]);

  const closeNotification = () => {
    setOpen(false);
  };

  const value = useMemo(
    () => ({ showNotification }),
    [showNotification]
  );

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <Snackbar
        className="notification"
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        message={message}
        autoHideDuration={3000}
        onClose={closeNotification}
      />
    </NotificationContext.Provider>
  );
};

export {
  NotificationProvider,
  useNotification
};
